// @flow
import React from 'react'
import LightboxForm from 'app/components/commons/LightboxForm'
import Button from 'mz-ui-kit/core/Button'
import { styled } from 'mz-ui-kit'

type Props = {
  isShowed: boolean,
  onCloseLightbox: () => void,
  onConfirmDelete: () => void,
  title?: string,
  message?: string,
}

const Container = styled('div', {
  padding: '20px',
  textAlign: 'center',
})

const Title = styled('h3', {
  marginBottom: '16px',
  fontSize: '18px',
  fontWeight: '500',
})

const Message = styled('p', ({ $palette }) => ({
  marginBottom: '24px',
  color: $palette ? $palette('TEXT_SECONDARY') : '#666',
}))

const ButtonsContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
})

const DeleteConfirmationModal = (props: Props) => {
  const {
    isShowed,
    onCloseLightbox,
    onConfirmDelete,
    title = 'Are you sure you want to delete this driver?',
    message = 'This action is irreversible. The driver will lose access immediately.',
  } = props

  const renderContent = () => (
    <Container>
      <Title>{title}</Title>
      <Message>{message}</Message>
      <ButtonsContainer>
        <Button onClick={onCloseLightbox}>Cancel</Button>
        <Button
          style={{ backgroundColor: '#B60C0C', borderColor: '#B60C0C' }}
          onClick={() => {
            onConfirmDelete()
            onCloseLightbox()
          }}
        >
          Delete
        </Button>
      </ButtonsContainer>
    </Container>
  )

  return (
    <LightboxForm
      isShowed={isShowed}
      onCloseLightbox={onCloseLightbox}
      render={renderContent}
    />
  )
}

export default DeleteConfirmationModal
